import { useState } from "react";
import BusIcon from "../assets/tmt-logo-new.png";
import { Nav, Navbar, NavDropdown, Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import AuthService from "../services/auth.service";
import { useStateContext } from "../contexts/ContextProvider";

const Header = () => {
  const navigate = useNavigate();
  const [openDropdown, setOpenDropdown] = useState(null);
  const username = AuthService.getCurrentUser()?.username;
  const { TEST_URL } = useStateContext();

  const handleLogout = () => {
    localStorage.clear();
    Object.keys(Cookies.get()).forEach((cookieName) => {
      Cookies.remove(cookieName, { path: "/" });
    });
    // window.location.href = `${TEST_URL}/Forms/login.aspx`;
    navigate("/");
    window.location.reload();
  };

  const handleMouseEnter = (dropdownId) => {
    setOpenDropdown(dropdownId);
  };

  const handleMouseLeave = () => {
    setOpenDropdown(null);
  };

  return (
    <>
      <div className="row">
        <div className="col-lg-12">
          <div className="main-header">
            <div className="left-flex">
              <div className="icon">
                <span>
                  <Link to={"/dutyList"}>
                    <img src={BusIcon} width={65} alt="" />
                  </Link>
                </span>
              </div>
              <div className="content">
                <h1>Thane Municipal Transport</h1>
                <Navbar expand="lg" className="bg-body-tertiary">
                  <Navbar.Toggle aria-controls="basic-navbar-nav" />
                  <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="me-auto">
                      <NavDropdown 
                        title="Posting" 
                        id="basic-nav-dropdown"
                        show={openDropdown === "posting"}
                        onMouseEnter={() => handleMouseEnter("posting")}
                        onMouseLeave={handleMouseLeave}
                      >
                         <NavDropdown.Item
                          href={`${TEST_URL}/Traffic/TrafficMainPagenew.aspx`}
                        >
                          Daily Posting Old
                        </NavDropdown.Item>
                        <NavDropdown.Item
                          href={`${TEST_URL}/DailyPostingAutomation/dutylist`}
                        >
                          Daily Posting Automated
                        </NavDropdown.Item>
                        <NavDropdown.Item
                          href={`${TEST_URL}/Traffic/Spare_duty_form.aspx`}
                        >
                          Spare Duty
                        </NavDropdown.Item>
                        <NavDropdown.Item
                          href={`${TEST_URL}/Traffic/PostingNewBook.aspx`}
                        >
                          Posting Book
                        </NavDropdown.Item>
                      </NavDropdown>
                      <NavDropdown 
                        title="Duty" 
                        id="basic-nav-dropdown"
                        show={openDropdown === "duty"}
                        onMouseEnter={() => handleMouseEnter("duty")}
                        onMouseLeave={handleMouseLeave}
                      >
                        <NavDropdown.Item
                          href={`${TEST_URL}/Traffic/TrafficPostedDuty.aspx`}
                        >
                          Posted Duty
                        </NavDropdown.Item>
                        <NavDropdown.Item
                          href={`${TEST_URL}/Traffic/Spare_duty_form.aspx`}
                        >
                          Spare Duty
                        </NavDropdown.Item>
                        <NavDropdown.Item
                          href={`${TEST_URL}/Traffic/trafficother.aspx`}
                        >
                          Control Point Duty
                        </NavDropdown.Item>
                        <NavDropdown.Item
                          href={`${TEST_URL}/Traffic/updateduty.aspx`}
                        >
                          Update Duty
                        </NavDropdown.Item>
                      </NavDropdown>
                      <Nav.Link href={`${TEST_URL}/Traffic/Turnout_book.aspx`}>
                        Bus TurnOut
                      </Nav.Link>
                      <Nav.Link
                        href={`${TEST_URL}/Traffic/TrafficLogSheetReceive.aspx`}
                      >
                        Logsheet Submit
                      </Nav.Link>
                      <NavDropdown 
                        title="Admin" 
                        id="basic-nav-dropdown"
                        show={openDropdown === "admin"}
                        onMouseEnter={() => handleMouseEnter("admin")}
                        onMouseLeave={handleMouseLeave}
                      >
                        <NavDropdown.Item
                          href={`${TEST_URL}/Traffic_Master/frmKMMaster.aspx`}
                        >
                          KM Master
                        </NavDropdown.Item>
                        <NavDropdown.Item
                          href={`${TEST_URL}/Traffic_Master/frmPlanBusStopMst.aspx`}
                        >
                          Planning Bus Stop
                        </NavDropdown.Item>
                        <NavDropdown.Item
                          href={`${TEST_URL}/Traffic_Master/frmDailyDutyMaster.aspx`}
                        >
                          Logsheet Master
                        </NavDropdown.Item>
                        <NavDropdown.Item
                          href={`${TEST_URL}/Traffic_Master/frmPlansheetMst.aspx`}
                        >
                          Planning Sheet
                        </NavDropdown.Item>
                        <NavDropdown.Item
                          href={`${TEST_URL}/Traffic_Master/frmDutyBrkUpMst.aspx`}
                        >
                          Duty Breakup Master
                        </NavDropdown.Item>
                        <NavDropdown.Item
                          href={`${TEST_URL}/Traffic_Master/master_board.aspx`}
                        >
                          Master Board
                        </NavDropdown.Item>
                        <NavDropdown.Item
                          href={`${TEST_URL}/Traffic_Master/TrafficReliverMaster.aspx`}
                        >
                          Reliver Board
                        </NavDropdown.Item>
                        <NavDropdown.Item
                          href={`${TEST_URL}/Traffic_Master/updateattendence.aspx`}
                        >
                          Update Attendence
                        </NavDropdown.Item>
                        <NavDropdown.Item
                          href={`${TEST_URL}/Traffic_Master/frmpenltyMst.aspx`}
                        >
                          Penalty Master
                        </NavDropdown.Item>
                        <NavDropdown.Item
                          href={`${TEST_URL}/Traffic_Master/log_sheet_view.aspx`}
                        >
                          Logsheet View
                        </NavDropdown.Item>
                        <NavDropdown.Item
                          href={`${TEST_URL}/Traffic_Master/deletelog.aspx`}
                        >
                          Delete Logsheet
                        </NavDropdown.Item>
                        <NavDropdown.Item
                          href={`${TEST_URL}/Traffic_Master/frmwrongDutymaster.aspx`}
                        >
                          Wrong Duty
                        </NavDropdown.Item>
                        <NavDropdown.Item
                          href={`${TEST_URL}/Traffic_Master/log_sheet_submission.aspx`}
                        >
                          Total Cancel Logsheet
                        </NavDropdown.Item>
                        <NavDropdown.Item
                          href={`${TEST_URL}/Traffic_Master/EmpMobile.aspx`}
                        >
                          Employee Mobile No
                        </NavDropdown.Item>
                        <NavDropdown.Item
                          href={`${TEST_URL}/Forms/usermaster.aspx`}
                        >
                          User Master
                        </NavDropdown.Item>
                        <NavDropdown.Item
                          href={`${TEST_URL}/Traffic/trafficoperationreport.aspx`}
                        >
                          Alloted Duty
                        </NavDropdown.Item>
                        <NavDropdown.Item
                          href={`${TEST_URL}/Traffic_Master/penaltyReport2023.aspx`}
                        >
                          Penalty Form 2023
                        </NavDropdown.Item>
                      </NavDropdown>
                      <Nav.Link
                        href={`${TEST_URL}/Traffic/trafficoperationreport.aspx`}
                      >
                        Traffic Report
                      </Nav.Link>
                    </Nav>
                  </Navbar.Collapse>
                </Navbar>
                {/* <p>
                  Daily Posting -{" "}
                  {moment(new Date(currentDate)).format("D MMM YYYY")}
                </p> */}
              </div>
            </div>
            <div className="right-flex">
              <div className="icon">
                <span>PG</span>
              </div>
              <div className="content">
                <h4>Welcome, {username && username !== "null" ? username : "Aeon"}</h4>
                {/* <p>Admin</p> */}
              </div>
            </div>
            <NavDropdown
              id="collapsible-nav-dropdown"
              className="profile-dropdown"
            >
              <p className="nav-link" onClick={handleLogout}>
                Logout
              </p>
            </NavDropdown>
          </div>
        </div>
      </div>
    </>
  );
};

export default Header;
